var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "agreement-viewer" },
    [
      _vm.expiredMessage
        ? _c(
            "div",
            {
              staticClass: "agreement-viewer__expired",
              attrs: { role: "status" }
            },
            [
              _c("div", { staticClass: "expired-document" }, [
                _vm._m(0),
                _c("div", { staticClass: "expired-document__message" }, [
                  _vm._v(_vm._s(_vm.expiredMessage))
                ])
              ])
            ]
          )
        : _vm.agreement
        ? _c("agreement-renderer", {
            ref: "AgreementRenderer",
            attrs: {
              agreement: _vm.agreement,
              signer: _vm.signer,
              "viewer-service": _vm.viewerService,
              appearance: _vm.effectiveAppearance,
              "in-frame": _vm.inFrame,
              "show-finish-warning": _vm.showWarning
            },
            on: { print: _vm.printAgreement, finalize: _vm.submitFinalized }
          })
        : _c(
            "div",
            { staticClass: "agreement-viewer__loading" },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: 36,
                  width: 3
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "expired-document__mockup",
        attrs: { "aria-hidden": "true" }
      },
      [
        _c("div", { staticClass: "expired-document__brand" }),
        _c("div", { staticClass: "expired-document__title" }),
        _c("div", { staticClass: "expired-document__subtitle" }),
        _c("div", { staticClass: "expired-document__section" }),
        _c("div", { staticClass: "expired-document__line wide" }),
        _c("div", { staticClass: "expired-document__line" }),
        _c("div", { staticClass: "expired-document__line short" }),
        _c("div", { staticClass: "expired-document__cards" }, [
          _c("span"),
          _c("span")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }